<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div
        class="fill"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="menuChange($event)"
        data-uiid="application-settings"
    >
        <div class="fill" [attr.name]="'Settings'" menuicon="fad fa-cogs" menusystemsubmenu>
            @for (group of groups; track group) {
                <div
                    class="fill settings-page"
                    [attr.name]="group.module"
                    [attr.menuItemId]="group.module"
                    [attr.menuicon]="group.icon"
                    menusystemitem
                >
                    <div class="search-area">
                        @if (group.allowFilter) {
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Filter / search"
                                [(ngModel)]="group.searchFilter"
                                (debounce-input-event)="filter(group.searchFilter, group.settings)"
                                inputTooltip
                            />
                        }
                    </div>
                    @if (group.module === activeTabName) {
                        <div class="row">
                            @for (setting of group.settings; track setting) {
                                @if (!group.allowFilter || !setting._hide) {
                                    <div
                                        class="{{
                                            setting.ValueType == valueType.Bit
                                                ? 'col-12 col-xl-6 col-xxl-4'
                                                : 'col-12'
                                        }}"
                                    >
                                        <div
                                            class="detail-page-card"
                                            [attr.data-uiid]="'setting-for-' + setting.ID"
                                        >
                                            <div class="detail-page-card-title">
                                                <label [for]="'value-' + setting.ID">{{
                                                    setting.Name
                                                }}</label>
                                            </div>
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    settingEditor;
                                                    context: { setting: setting }
                                                "
                                            >
                                            </ng-container>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}

<ng-template #settingEditor let-setting="setting">
    @switch (setting.ValueType) {
        <!-- Default ValueType (Text) -->
        @default {
            <div class="detail-page-card-body padded">
                <input
                    [id]="'value-' + setting.ID"
                    type="text"
                    [name]="'textvalue-' + setting.ID"
                    class="form-control"
                    [(ngModel)]="setting.TextValue"
                    (blur)="SaveChange(setting)"
                    inputTooltip
                />
            </div>
        }
        <!-- Boolean -->
        @case (valueType.Bit) {
            <mat-slide-toggle
                [id]="'value-' + setting.ID"
                name="boolvalue"
                class="boolswitch"
                (change)="UpdateSwitchAndSave($event, setting)"
                [checked]="setting.BoolValue"
                size="small"
                color="primary"
            >
            </mat-slide-toggle>
        }
        <!-- Number -->
        @case (valueType.Number) {
            <div class="detail-page-card-body padded">
                <input
                    [id]="'value-' + setting.ID"
                    type="number"
                    [name]="'numbervalue-' + setting.ID"
                    class="form-control"
                    [(ngModel)]="setting.NumberValue"
                    (blur)="SaveChange(setting)"
                />
            </div>
        }
        <!-- Dropdown -->
        @case (valueType.Dropdown) {
            <div class="detail-page-card-body padded">
                <select
                    [id]="'value-' + setting.ID"
                    class="form-select"
                    [name]="'dropdownvalue-' + setting.ID"
                    [(ngModel)]="setting.SelectedDropdownOption"
                    (change)="UpdateDropdownAndSave(setting)"
                >
                    @for (option of setting.DropdownOptions; track option) {
                        <option [value]="option">
                            {{ option }}
                        </option>
                    }
                </select>
            </div>
        }
        <!-- Base64Img -->
        @case (valueType.Base64Img) {
            <div class="detail-page-card-actions">
                <button class="btn btn-raised" (click)="SaveChange(setting)">Save image</button>
                <button
                    class="btn btn-raised red"
                    (click)="setting.SerializedOption = ''; SaveChange(setting)"
                >
                    Clear image
                </button>
            </div>
            <div class="detail-page-card-body padded">
                <input
                    [id]="'value-' + setting.ID"
                    type="file"
                    (change)="Base64ImageChanged($event, setting)"
                    accept="image/png, image/gif, image/jpeg, image/bmp"
                />
                @if (setting.SerializedOption) {
                    <img [src]="setting.SerializedOption" class="base64image" />
                }
            </div>
        }
        <!-- Color -->
        @case (valueType.Color) {
            <div class="detail-page-card-actions">
                <button class="btn btn-raised" (click)="SaveColorSetting(setting)">
                    Save color
                </button>
            </div>
            <div class="detail-page-card-body padded">
                <cerrix-color-select
                    [id]="'value-' + setting.ID"
                    [(value)]="setting.SerializedOption"
                >
                </cerrix-color-select>
            </div>
        }
        @case (valueType.Action) {
            <div class="detail-page-card-body padded">
                <button class="btn btn-raised" (click)="HandleActionButton(setting)">
                    {{ setting.Name }}
                </button>
                <i class="far fa-info-circle mx-2" [matTooltip]="setting.TextValue"> </i>
                <textarea
                    [id]="'value-' + setting.ID"
                    type="text"
                    [name]="'textvalue-' + setting.ID"
                    class="form-control"
                    [(ngModel)]="setting.SerializedOption"
                    inputTooltip
                    readonly="true"
                >
                </textarea>
            </div>
        }
        <!-- Json -->
        @case (valueType.Json) {
            <div class="detail-page-card-body padded">
                @if (setting.isSdDropDown) {
                    <select
                        [id]="'value-' + setting.ID"
                        class="form-select"
                        [name]="'dropdownvalue-' + setting.ID"
                        [(ngModel)]="setting.SelectedDropdownOption"
                        (change)="UpdateSdDropdownAndSave(setting)"
                    >
                        @for (option of setting.DropdownOptions; track option) {
                            <option [value]="option">
                                {{ option }}
                            </option>
                        }
                    </select>
                    <select
                        [id]="'sddropdownsettings-' + setting.ID"
                        class="form-select mt-2"
                        [name]="'sddropdownsettings-' + setting.ID"
                        [disabled]="
                            !standingDataDropDownOptions[
                                setting.Name + '-' + setting.SelectedDropdownOption
                            ]
                        "
                        [(ngModel)]="setting.selectedStandingDataDropdownId"
                        (change)="UpdateSdDropdownAndSave(setting)"
                    >
                        @for (
                            option of standingDataDropDownOptions[
                                setting.Name + "-" + setting.SelectedDropdownOption
                            ];
                            track option
                        ) {
                            <option [value]="option.ID">
                                {{ option.Name }}
                            </option>
                        }
                    </select>
                }
            </div>
        }
    }
</ng-template>
